import { Form } from "antd";
import { useContext, useEffect, useState } from "react";
import CustomDropdown from "../../../component/CustomDropdown";
import CustomSingleDropdown from "../../../component/CustomeSigleDropDown";
import FilledButton from "../../../component/FilledButton";
import FormInput from "../../../component/FormInput";
import { ContextState } from "../../../layout";

const AddUser = ({ btnLoader, userId, attachCourse, errorData, handleError, handleAddUser, category, handleChange, formData, handleModalClose, setFormRef, startDateDataFromCourse, handleStartDateChange }) => {
    const [form] = Form.useForm();
    form.setFieldsValue(formData);
    const { contextReducer } = useContext(ContextState);

 

    useEffect(() => {
        setFormRef(form);
    }, []);


    const skillUpRoll = [ {
        id: 1,
        name: "Temp User"
    }]

    return (
        <div className="modal_body">
            <div className="add_thought_leader">
                <Form
                    form={form}
                    name="register"
                    onFinish={(e) => handleAddUser(e, form)}
                    onReset={handleModalClose}
                    scrollToFirstError
                    className="attached_courses-add_skill"
                >
                    <h2>{attachCourse ? 'link course' : userId ? 'Edit User' : 'add user'}</h2>
                    <Form.Item name="email">
                        <FormInput
                            label="Email *"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            error={errorData['email']}
                            onFocus={(e) => handleError(e)}
                            disabled={attachCourse || userId ? true : false}
                        />
                    </Form.Item>

                    {(!attachCourse || userId) && <>
                        <Form.Item name="first_name">
                            <FormInput
                                label={"First Name"} 
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                error={errorData['first_name']}
                                onFocus={(e) => handleError(e)}
                            />
                        </Form.Item>

                        <Form.Item name="last_name">
                            <FormInput
                                label={"Last Name"} 
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                error={errorData['last_name']}
                                onFocus={(e) => handleError(e)}
                            />
                        </Form.Item>
                    </>}

                    { !userId &&
                        <>
                            <CustomSingleDropdown
                                options={skillUpRoll}
                                name="role"
                                forlabel='User Role *'
                                value={formData.user_role}
                                onChange={handleChange}
                                error={errorData['role']}
                                onFocus={() => handleError({ target: { name: "role" } })}
                                showSearch
                            />

                        </>}
                    
                    <div class="form_group form_footer d_flex_center">
                        <button type="reset" className="btn btn_gray">cancel</button>
                        <FilledButton type="submit" loading={btnLoader} value={userId ? "update" : "invite"} className="btn btn_primary" />
                    </div>
                </Form>
            </div>
        </div>
    )
};

export default AddUser;